import React from 'react';
import { Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { getWixAppStoreLink } from 'utils/wixAppStore';
import { postPurchaseBi } from '../postPurchaseBi';
import styles from '../PostPurchaseStep.scss';

export function MobileDesktopSetupNotice() {
  const { t } = useTranslation();
  const wixAppStoreLink = getWixAppStoreLink();

  function handleWixAppLinkClick() {
    if (wixAppStoreLink) {
      postPurchaseBi.wixAppLink(wixAppStoreLink.provider);
    }
  }

  return (
    <div className={styles.postPurchaseMobileSetupNotice}>
      <Text size="small" secondary>
        {t('post_purchase.mobile_setup_notice.desktop')}
      </Text>
      <Text size="small" secondary>
        {wixAppStoreLink ? (
          <Trans
            i18nKey="post_purchase.mobile_setup_notice.app_link"
            components={{
              appLink: (
                <TextButton
                  as="a"
                  size="small"
                  underline="always"
                  href={wixAppStoreLink.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleWixAppLinkClick}
                />
              ),
            }}
          />
        ) : (
          t('post_purchase.mobile_setup_notice.app_generic')
        )}
      </Text>
    </div>
  );
}
